import request from '@/utils/request'
import requestl from '@/utils/requestl'
//注册
export function regist(params) {
  return request({                            //注册账户
    url: "/reg/regist",
    method: "post",
    data:params
  })
}

export function sendPhoneValidCode(params) {
    return request({                            //注册-发送短信验证码
      url: "/sms/user/sendPhoneValidCode",
      method: "post",
      data:params
    })
}

//登录
export function getLosinCode(params) {
    return request({                            //登录-发送短信验证码
      url: "/sms/user/sendPhoneValidCode/login",
      method: "post",
      data:params
    })
}

export function userPaswrodLosin(params) {
    return request({                            //密码登录
      url: "/auth/login",
      method: "post",
      data:params
    })
}

export function userCodeLosin(params) {
    return request({                            //短信登录
      url: "/auth/loginSms",
      method: "post",
      data:params
    })
}

export function getuserInfo(params) {
  return request({                            //获取用户信息
    url: '/user/getUser',
    method: 'post',
    data:params
  })
}

export function outLogin(params) {
  return request({                            //退出登录
    url: "/auth/logout",
    method: "post",
    data:params
  })
}

export function findPassword(params) {
  return request({                            //手机找回密码
    url: "/auth/findPassword",
    method: "post",
    data:params
  })
}

export function getForgetPassCode(params) {
  return request({                            //忘记密码-找回密码短信验证码
    url: "/sms/smsForgetMobile",
    method: "post",
    data:params
  })
}

//文章列表
export function getNewList(params) {
  return request({                            //网站文章列表-分页查询
    url: "/appConfig/listArticle",
    method: "get",
    data:params
  })
}

export function getNewsInfo(params) {
  return request({                            //网站文章详情
    url: "/appConfig/getArticle",
    method: "get",
    data:params
  })
}

export function isCollection(params) {
  return request({                            //取消 收藏
    url: "/wjsgw/userInfos/gwusercollect/remove/"+params.id,
    method: "POST",
    data:params
  })
}


export function getNavList(params) {
  return request({                            //网站导航管理-导航key
    url: "/appConfig/getByKey",
    method: "get",
    data:params
  })
}

export function gwannouncementList(params) {
  return request({                            //招投标公告-分页查询
    url: "/wjsgw/bid/gwannouncement/list",
    method: "POST",
    data:params
  })
}

export function gwannouncementGet(params) {
  return request({                            //招投标公告-获取公告详情
    url: "/wjsgw/bid/gwannouncement/get/"+params.id,
    method: "GET",
    data:params
  })
}

export function downloadBidFile(params) {
  return request({                            //招投标公告-附件下载
    url: "/wjsgw/bid/gwannouncement/downloadBidFile",
    method: "GET",
    data:params,
    download: true
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js